import trashTariff from './trash-tariff'
import car from './car'

export default {
  name: 'FinancialTrashTariff',
  path: 'trash',
  meta: {
    label: 'trash',
    auth: 'trash'
  },
  component: {
    name: 'Trash',
    render(c) {
      return c('router-view')
    }
  },
  children: [trashTariff, car]
}
